import React from 'react';
import classes from './DisabledCustomizedPostStatusLabel.module.scss';
import { ReadonlyGroupPostAttributesType } from '../../../models/post-editor';
import { PostStatus } from '../../../models/graphql';
import classNames from 'classnames';

export type DisabledCustomizedPostStatusLabelViewProps = {
  post: ReadonlyGroupPostAttributesType;
};

export const DisabledCustomizedPostStatusLabelView = ({
  post
}: DisabledCustomizedPostStatusLabelViewProps): JSX.Element => {
  const { postStatus } = post;
  let itemLabel: string;
  switch (postStatus) {
    case PostStatus.ACTIVE:
      itemLabel = 'Active';
      break;
    case PostStatus.DRAFT:
      itemLabel = 'Draft';
      break;
    case PostStatus.PUBLISHED:
      itemLabel = 'Past';
      break;
    case PostStatus.FAILED:
      itemLabel = 'Failed';
      break;
    default:
      itemLabel = 'Unknown';
      break;
  }
  const itemClasses = classNames(classes.PostStatusDot, {
    [classes.PostStatusDotActive]: postStatus === PostStatus.ACTIVE,
    [classes.PostStatusDotDraft]: postStatus === PostStatus.DRAFT,
    [classes.PostStatusDotPast]: postStatus === PostStatus.PUBLISHED,
    [classes.PostStatusDotFailed]: postStatus === PostStatus.FAILED
  });
  return (
    <div className={classNames(classes.DisabledCustomizedPostStatusLabel)}>
      <div className={'grid-x align-middle'}>
        <div className={'cell shrink'}>
          <div className={itemClasses}>
            <span className={'show-for-sr'}>{postStatus}</span>
          </div>
        </div>
        <div className={'cell shrink'}>
          <div className={classes.ValueLabel}>{itemLabel}</div>
        </div>
      </div>
    </div>
  );
};
